module.exports = __webpack_public_path__ + "static/img/id-card-front.669afce2.png";